import { useRef, useState } from "react";

import { State } from "../../components/reactOL/source";
import styled, { css, keyframes } from "styled-components";

import YearSelect from "../../components/yearSelect/YearSelect";
import BoundaryMap from "../../components/map/BoundaryMap";
import Legend from "../../components/legend/Legend";
import BoundaryTypeahead from "../../components/boundarySearch/BoundaryTypeahead";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const MapContainer = styled.div<{ showSpinner: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #aad3df;
  overflow: hidden;

  ${({ showSpinner }) =>
    showSpinner &&
    css`
      :after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        margin-top: -20px;
        margin-left: -20px;
        border-radius: 50%;
        border: 5px solid rgba(180, 180, 180, 0.6);
        border-top-color: rgba(0, 0, 0, 0.6);
        animation: ${spin} 0.6s linear infinite;
      }
    `}
`;

const DropDownContainer = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 50;
`;

const LegendContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 50;
`;

const TypeaheadContainer = styled.div`
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  width: 350px;
`;

const MapPage = () => {
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [loadingState, setLoadingState] = useState<State>(State.Unloaded);
  const years = [2022, 2023, 2024, 2025];
  const [year, setYear] = useState(2022);

  return (
    <MapContainer
      ref={mapContainerRef}
      showSpinner={loadingState === State.Loading}
    >
      <DropDownContainer>
        <YearSelect year={year} years={years} setYear={setYear} />
      </DropDownContainer>{" "}
      <TypeaheadContainer>
        <BoundaryTypeahead />{" "}
      </TypeaheadContainer>
      <LegendContainer>
        <Legend />
      </LegendContainer>
      <BoundaryMap setLoadingState={setLoadingState} year={year} />
    </MapContainer>
  );
};

export default MapPage;
